export default __webpack_public_path__ + "static/media/EventoDemo.9481ac9d.pdf";